// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__EJCWT","title":"panel_title__CmVAV","body":"panel_body__smjB2"};